import React from 'react';
import { Icon } from '@hz-design-system/web-ui';
import { Trans } from '@ecg-marktplaats/js-react-i18n';
import { ListingAttribute } from '@/client/components/ListingsNew/components';

interface ListingTrustIndicatorsProps {
  trustIndicators?: { value?: string; key: string }[];
}

const ListingTrustIndicators: React.FC<ListingTrustIndicatorsProps> = ({ trustIndicators }) => {
  if (!trustIndicators?.length) {
    return null;
  }

  return (
    <div className={'hz-Listing-trust-items'}>
      {trustIndicators.map((trustIndicator, key) => (
        <ListingAttribute type="trust-item" key={key}>
          <Icon name="checkmark-circle" color="success" />
          <Trans tagName="span" i18nKey={`trustIndicator.${trustIndicator.key}`} />
        </ListingAttribute>
      ))}
    </div>
  );
};

export default ListingTrustIndicators;
